import { render, staticRenderFns } from "./UpgradeToPro.vue?vue&type=template&id=105a861f&scoped=true"
import script from "./UpgradeToPro.vue?vue&type=script&lang=js"
export * from "./UpgradeToPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105a861f",
  null
  
)

export default component.exports